"use client";

import { FC, useEffect, useRef, useState } from "react";
import LeftMenu from "./LeftMenu";
import RightMenu from "./RightMenu";
import { HeaderNavigationProps } from "../../interfaces/IHeader.interface";

const SCROLL_DELTA_THRESHOLD = 10;
const TOP_OFFSET_THRESHOLD = 85;

const HeaderNavigation: FC<HeaderNavigationProps> = ({ topnavigation, bottomnavigationmobile }) => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  const navItems =
    topnavigation?.children?.find((child) => child.nodeName === "topNavList")?.children || [];
  const navRightItems =
    topnavigation?.children?.find((child) => child.nodeName === "options")?.children || [];

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= TOP_OFFSET_THRESHOLD) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY.current + SCROLL_DELTA_THRESHOLD) {
        setIsVisible(false);
      }

      lastScrollY.current = currentScrollY;
    };

    lastScrollY.current = window.scrollY;
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--desktop-header-height",
      isVisible ? "65px" : "87px"
    );
    document.documentElement.style.setProperty(
      "--desktop-header-extra-height",
      isVisible ? "0px" : "22px"
    );

    return () => {
      document.documentElement.style.removeProperty("--desktop-header-height");
      document.documentElement.style.removeProperty("--desktop-header-extra-height");
    };
  }, [isVisible]);

  return (
    <div
      aria-label="Main Navigation"
      className={`header-navigation menu-header-bar fixed left-0 top-[var(--desktop-header-height,65px)] w-full bg-blue-800 whitespace-nowrap text-white ${isVisible ? "translate-y-0 z-11" : "-translate-y-full z-5"}`}
    >
      <div className="header-navigation-inner mx-auto flex w-full max-w-360 justify-between">
        <LeftMenu bottomnavigationmobile={bottomnavigationmobile} navItems={navItems} />
        <RightMenu navRightItems={navRightItems} />
      </div>
    </div>
  );
};

export default HeaderNavigation;
